/**
 * Check if the option is one of the paying options
 * @param {Array<string>} payingOptions - list of options available to the user
 * @param {string} option - option to look for
 * @returns {boolean} - true if the user has the option
 */
function hasPayingOption(payingOptions, option) {
  return payingOptions && payingOptions.includes(option);
}

module.exports = hasPayingOption;
